import React from 'react';
import './footer.css';
import '../LandingPage/LandingPage.css';
import {BrowserRouter as Router, Link} from "react-router-dom";
import {footer} from "../../data";

// const onload = function() {
// 	if(!window.location.hash) {
// 		window.location = window.location + '';
// 		window.location.reload();
// 	}
// }


function App() {
  return (
    <Footer22
      group8622Props={footer22Data.group8622Props}
      frame53Props={footer22Data.frame53Props}
      frame6Props={footer22Data.frame6Props}
      frame7Props={footer22Data.frame7Props}
    />
  );
}

export default App;

function Footer22(props) {
  const { group8622Props, frame53Props, frame6Props, frame7Props } = props;

  return (
    <div className="fd-footer">
      <div className="fd-frame-1585">
        <Frame1578
          overlapGroup2={group8622Props.overlapGroup2}
          vector2={group8622Props.vector2}
          group86222Props={group8622Props.group86222Props}
          facebookAppSymbol3Props={group8622Props.facebookAppSymbol3Props}
          twitter3Props={group8622Props.twitter3Props}
        />
        <Frame53 text40={frame53Props.text40} frame4Props={frame53Props.frame4Props} />
        <Frame6
          text48={frame6Props.text48}
          frame42Props={frame6Props.frame42Props}
          frame422Props={frame6Props.frame422Props}
        />
        <Frame7 text56={frame7Props.text56} frame4Props={frame7Props.frame4Props} />
      </div>
      
    </div>
  );
}


function Frame1578(props) {
  const { overlapGroup2, vector2, group86222Props, facebookAppSymbol3Props, twitter3Props } = props;

  return (
    <div className="fd-frame-1578">
      <Group86222 group85={group86222Props.group85} whiteProps={group86222Props.whiteProps} />
      <div className="fd-frame-1584">
        <Group324 />
        <div className="fd-frame-1583">
          <FacebookAppSymbol3 src={facebookAppSymbol3Props.src} />
          <div className="fd-instagram">
            <div className="fd-overlap-group">
              {/* <img
                className="fd-vector"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-95@2x.svg"
              /> */}
              {/* <img className="fd-vector-1" src={vector2} /> */}
              <img 
                src={footer.Instagram}
              />
            </div>
          </div>
          <Twitter3 src={twitter3Props.src} />
        </div>
      </div>
    </div>
  );
}


function Group86222(props) {
  const { group85, whiteProps } = props;

  return (
    <Link to="/home">
    <div className="fd-group-86">
      <White src={whiteProps.src} />
      {/* <img className="fd-group-85" src={group85} /> */}
      <img className="fd-group-85" src={footer.Webuildd} />
    </div>
    </Link>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="fd-white">
      <img className="fd-vector-2" src={src} />
    </div>
  );
}


function Group324() {
  return (
    <div className="fd-group-32">
      
      <div className="fd-group-189">
        <div className="fd-map-pin-1">
          <div className="fd-overlap-group-1">
            <img src="/Images/Footer/location-icon.svg"/>
          </div>
        </div>
        <p className="fd-text-1 fd-typographybody16-regular">
          BSR Memoirs, No. 15, New BEL Road, Chikkamaranahalli, RMV 2nd Stage Bangalore 560094, Karnataka.
        </p>
      </div>
      <div className="fd-group-18">
        <div className="fd-phone">  {/* Link is in style "style={{ backgroundImage: `url(${phone})` }}" */}
        <img className="fd-vector-4" src={footer.Phone}   />
          {/* <img className="fd-vector-4" src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d70c933a473832a7d2b923/img/phone-1@2x.svg"/> */}
        </div>
        <div className="fd-text fd-valign-text-middle fd-typographybody16-regular">+91-9845408111</div>
      </div>
      <div className="fd-group-18">
        <div className="fd-mail">
          <div className="fd-overlap-group-2">
            <img
              
              src={footer.Mail}
              />
            {/* <img
              className="fd-vector-5"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d70c933a473832a7d2b923/img/phone-1@2x.svg"
            /> */}
          </div>  
        </div>
        <div className="fd-text fd-valign-text-middle fd-typographybody16-regular">hari.krishna@webuildd.com</div>
      </div>
    </div>
  );
}


function FacebookAppSymbol3(props) {
  const { src } = props;

  return (
    <div className="fd-facebook-app-symbol">
      {/* <img className="fd-f-1" src={src} /> */}
      <img className="fd-f-1" src={footer.Facebook} />
    </div>
  );
}


function Twitter3(props) {
  const { src } = props;

  return (
    <div className="fd-twitter">
      {/* <img className="fd-vector-6" src={src} /> */}
      <img className="fd-vector-6" src={footer.Twitter} /> 
    </div>
  );
}


function Frame53(props) {
  const { text40, frame4Props } = props;

  return (
    <div className="fd-frame-5">
      <div className="fd-text-4 fd-valign-text-middle fd-typographyheadlineh5-extrabold-20">{text40}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
        text48={frame4Props.text48}
        url41={frame4Props.url41}
        url42={frame4Props.url42}
        url43={frame4Props.url43}
        url44={frame4Props.url44}
        url45={frame4Props.url45}
        url46={frame4Props.url46}
        url47={frame4Props.url47}
        url48={frame4Props.url48}
      />
    </div>
  );
}


function Frame4(props) {
  const { text41, text42, text43, text44, text45, text46, text47, text48, url41, url42, url43, url44, url45, url46, url47, url48 } = props;

  return (
    <div className="fd-frame-4">
      <Link to={`${url41}`}>
        <div className="fd-text-2 fd-valign-text-middle fd-typographybody16-regular">{text41}</div>
      </Link>
      <Link to={`${url42}`}>
        <div className="fd-text-3 fd-valign-text-middle fd-typographybody16-regular">{text42}</div>
      </Link>
      <Link to={`${url43}`}>
        <div className="fd-text-3 fd-valign-text-middle fd-typographybody16-regular">{text43}</div>
      </Link>
      <Link to={`${url44}`}>
        <div className="fd-text-3 fd-valign-text-middle fd-typographybody16-regular">{text44}</div>
      </Link>
      <Link to={`${url45}`}>
        <div className="fd-text-3 fd-valign-text-middle fd-typographybody16-regular">{text45}</div>
      </Link>
      <Link to={`${url46}`}>
        <div className="fd-text-3 fd-valign-text-middle fd-typographybody16-regular">{text46}</div>
      </Link>
      <Link to={`${url47}`}>
        <div className="fd-text-3 fd-valign-text-middle fd-typographybody16-regular">{text47}</div>
      </Link>
      <Link to={`${url48}`}>
        <div className="fd-text-3 fd-valign-text-middle fd-typographybody16-regular">{text48}</div>
      </Link>
    </div>
  );
}


function Frame6(props) {
  const { text48, frame42Props, frame422Props } = props;

  return (
    <div className="fd-frame-6">
      <div className="fd-text-12 fd-valign-text-middle fd-typographyheadlineh5-extrabold-20">{text48}</div>
      <div className="fd-frame-1577">
        <Frame42
          text49={frame42Props.text49}
          text50={frame42Props.text50}
          place={frame42Props.place}
          text51={frame42Props.text51}
          text52={frame42Props.text52}
          urlB={frame42Props.urlB}
          urlS={frame42Props.urlS}
          urlP={frame42Props.urlP}
          urlL={frame42Props.urlL}
          urlB1={frame42Props.urlB1}
          urlS2={frame42Props.urlS2}
          urlP3={frame42Props.urlP3}
          urlL4={frame42Props.urlL4}
        />
        <Frame42
          text49={frame422Props.text49}
          text50={frame422Props.text50}
          place={frame422Props.place}
          text51={frame422Props.text51}
          text52={frame422Props.text52}
          className={frame422Props.className}
          urlB={frame422Props.urlB}
          urlS={frame422Props.urlS}
          urlP={frame422Props.urlP}
          urlL={frame422Props.urlL}
          urlB1={frame422Props.urlB1}
          urlS2={frame422Props.urlS2}
          urlP3={frame422Props.urlP3}
          urlL4={frame422Props.urlL4}
        />
      </div>
    </div>
  );
}


function Frame42(props) {
  const { text49, text50, place, text51, text52, urlB, urlS, urlP, urlL, urlB1, urlS2, urlP3, urlL4, className } = props;

  return (
    <div className={`fd-frame-4-1 ${className || ""}`}>
      <div className="fd-text-13 fd-valign-text-middle fd-overpass-extra-bold-white-16px">{text49}</div>
      <div className="fd-frame-1580">
        <Router forceRefresh={true}>
          <Link to={`/packagedetails/${urlB}/${urlB1}`}>
            <div className="fd-text-1-1 fd-valign-text-middle fd-typographybody16-regular">{text50}</div>
          </Link>
          <Link to={`/packagedetails/${urlS}/${urlS2}`} >
            <div className="fd-place fd-valign-text-middle fd-typographybody16-regular">{place}</div>
          </Link>
          <Link to={`/packagedetails/${urlP}/${urlP3}`}>
            <div className="fd-text-15 fd-valign-text-middle fd-typographybody16-regular">{text51}</div>
          </Link>
          <Link to={`/packagedetails/${urlL}/${urlL4}`}>
            <div className="fd-text-16 fd-valign-text-middle fd-typographybody16-regular">{text52}</div>
          </Link>
        </Router>
      </div>
    </div>
  );
}


function Frame7(props) {
  const { text56, frame4Props } = props;

  return (
    <div className="fd-frame-7">
      <div className="fd-text-20 fd-valign-text-middle fd-typographyheadlineh5-extrabold-20">{text56}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
        text48={frame4Props.text48}
        url41={frame4Props.url41}
        url42={frame4Props.url42}
        url43={frame4Props.url43}
        url44={frame4Props.url44}
        url45={frame4Props.url45}
        url46={frame4Props.url46}
        url47={frame4Props.url47}
        url48={frame4Props.url48}
      />
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-88@2x.svg",
};

const group86222Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
    whiteProps: whiteData,
};

const facebookAppSymbol3Data = {
    //src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1@2x.svg",
    src :"https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d70c933a473832a7d2b923/img/facebook-app-symbol-1@2x.svg"
};

const twitter3Data = {
    //src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-97@2x.svg",
    src : "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d434f90f59a872fbd1cefc/img/twitter@2x.svg"
};

const frame1578Data = {
    overlapGroup2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d70c933a473832a7d2b923/img/instagram-1@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-96@2x.svg",
    group86222Props: group86222Data,
    facebookAppSymbol3Props: facebookAppSymbol3Data,
    twitter3Props: twitter3Data,
};

const frame4Data = {
    text41: "About Us",
    text42: "Projects",
    text43: "Videos",
    text44: "Packages",
    text45: "Insights",
    text46: "Blogs",
    text47: "FAQ’s",
    text48: "",
    url41: "/about",
    url42: "/project",
    url43: "/video",
    url44: "/packagedetailsftr/1/1",
    url45: "/insight",
    url46: "/blog",
    url47: "/faq",
    url48: "",
};

const frame53Data = {
    text40: "Quick Links",
    frame4Props: frame4Data,
};

const frame42Data = {
    text49: "Construction",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
    urlB: "1",
    urlS: "1",
    urlP: "1",
    urlL: "1",
    urlB1: "1",
    urlS2: "2",
    urlP3: "3",
    urlL4: "4",
};

const frame422Data = {
    text49: "Interior",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
    className: "fd-frame-5-1",
    urlB: "2",
    urlS: "2",
    urlP: "2",
    urlL: "2",
    urlB1: "1",
    urlS2: "2",
    urlP3: "3",
    urlL4: "4",

};

const frame6Data = {
    text48: "Packages",
    frame42Props: frame42Data,
    frame422Props: frame422Data,
};

const frame43Data = {
    text41: "BBMP",
    text42: "BWSSB",
    text43: "BESCOM",
    text44: "Procedure",
    text45: "Vaastu",
    text46: "Bye Laws",
    text47: "Tips & Ideas",
    text48: "Budget",
    url41: "/insightdetails-bbmp",
    url42: "/insightdetails-bwssb",
    url43: "/insightdetails-bescom",
    url44: "/insightdetails-procedure",
    url45: "/insightdetails-vaastu",
    url46: "/insightdetails-byelaws",
    url47: "/insightdetails-tips&ideas",
    url48: "/insightdetails-budget",
};

const frame7Data = {
    text56: "Insights",
    frame4Props: frame43Data,
};

const footer22Data = {
    group8622Props: frame1578Data,
    frame53Props: frame53Data,
    frame6Props: frame6Data,
    frame7Props: frame7Data,
};

